import { api } from "@/lib/api-client";

export interface RetentionItem {
  id: string;
  displayId: string;
  filename: string;
  jobTypeId: string;
  jobTypeName: string;
  retentionExpiresAt: string;
  minutesRemaining: number;
  thumbnailPath: string | null;
}

interface RetentionQueueResponse {
  items: RetentionItem[];
}

export function getRetentionQueue(jobTypeId?: string): Promise<RetentionItem[]> {
  const path = jobTypeId
    ? `/retention?jobTypeId=${encodeURIComponent(jobTypeId)}`
    : "/retention";
  return api.get<RetentionQueueResponse>(path).then((r) => r.items);
}

/** Move a retained document back to an earlier pipeline step. */
export function moveBack(id: string, stepType: string): Promise<void> {
  return api.post(`/documents/${id}/move-back`, { stepType });
}

/** Re-OCR a retained document. */
export function reprocess(id: string): Promise<void> {
  return api.post(`/documents/${id}/reprocess`, {});
}

/** Delete images for a retained document immediately (destructive). */
export function purgeNow(id: string): Promise<void> {
  return api.post(`/documents/${id}/purge`, {});
}
